import React from "react";
import { STATUS, FLAGS } from "@/lib/constants";

// Afmeting 1/2/3 = klein/middel/groot; px = werkelijke diameter, zodat het label altijd leesbaar blijft
export default function PitchMarker({ p, x, y, lang, editable, px = 24, onMouseDown, onTouchStart, onClick, onMouseEnter, onMouseLeave, highlight = false, handover = false, handoverText = "" }) {
  const st = STATUS[p.status] || STATUS.vrij;
  const needsCheck = !!p.controle_nodig;
  const oos = p.status === "buiten_dienst";
  const shape = p.shape || (p.kind === "bungalow" || p.kind === "cabin" ? "square" : "circle");
  const radius = shape === "circle" ? "rounded-full" : "rounded-[3px]";
  const rot = shape === "diamond" ? " rotate(45deg)" : "";
  const ring = p.rood_lintje ? `0 0 0 2px ${FLAGS.rood_lintje.color}` : "0 1px 2px rgba(0,0,0,.35)";
  const label = p.label || String(p.number);
  const inner = shape === "diamond" ? px * 0.7 : px;
  const font = Math.max(5, Math.min(inner * 0.46, (inner * 0.92) / (label.length * 0.62)));
  const oosTip = oos ? ` · ${p.note || ""}${p.oos_until ? ` (tot ${new Date(p.oos_until).toLocaleDateString("nl-BE")})` : ""}` : "";
  return (
    <button
      onMouseDown={onMouseDown}
      onTouchStart={onTouchStart}
      onClick={onClick}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      title={!onMouseEnter ? `${label} · ${st[lang] || st.nl}${oosTip}${handover ? ` · ${handoverText}` : ""}${p.guest_name ? " · " + p.guest_name : ""}${p.rood_lintje && !p.rood_lintje_active ? ` · ${lang === "es" ? "libre hasta" : "vrij tot"} ${new Date(p.rood_lintje_from).toLocaleDateString("nl-BE")} (${p.rood_lintje_guest})` : ""}` : undefined}
      data-testid={`pitch-${label}`}
      className={`absolute grid place-items-center font-bold text-white transition-transform hover:scale-125 hover:z-30 focus:outline-none focus:ring-2 focus:ring-primary ${radius} ${editable ? "cursor-move" : "cursor-pointer"} ${highlight ? "z-40 animate-pulse" : ""}`}
      style={{
        left: `${x}%`, top: `${y}%`, width: px, height: px,
        transform: `translate(-50%, -50%)${rot}`,
        background: needsCheck && !oos ? FLAGS.controle_nodig.color : st.color,
        backgroundImage: oos
          ? "repeating-linear-gradient(45deg, rgba(255,255,255,.45) 0 2px, transparent 2px 5px)"
          : undefined,
        border: needsCheck && !oos ? `2px solid ${st.color}` : "1px solid rgba(255,255,255,.9)",
        boxShadow: highlight ? "0 0 0 4px rgba(14,165,233,.9), 0 0 16px 6px rgba(14,165,233,.6)" : ring,
      }}
    >
      <span className="leading-none tracking-tight" style={{ fontSize: font, transform: rot ? "rotate(-45deg)" : undefined }}>{label}</span>
      {handover && !editable && (
        <span
          data-testid={`pitch-handover-${label}`}
          title={handoverText}
          className="absolute -top-0.5 -right-0.5 grid place-items-center rounded-full bg-amber-400 ring-2 ring-white shadow"
          style={{ width: Math.max(8, px * 0.34), height: Math.max(8, px * 0.34), transform: rot ? "rotate(-45deg)" : undefined }}
        >
          <span className="rounded-full bg-amber-700" style={{ width: "40%", height: "40%" }} />
        </span>
      )}
    </button>
  );
}
